import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = {
    auditRatingColor: getInitialState.list(),
    auditRatingCategories: [],
    auditOrgRatingThreshold: [],
    item: {}
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.AUDIT_RATING_CLEAR: {
            return {};
        }
        case actionTypes.AUDIT_RATING_ITEM_SET: {
            const { auditRating } = action.payload;
            return { ...state, item: auditRating };
        }
        case actionTypes.AUDIT_RATINGS_CORE_GET_SUCCESS: {
            const { auditRating } = action.payload;
            return auditRating;
        }
        default: {
            return state;
        }
    }
}
